import { batchCheckpointsTags } from '../pages/BatchCheckpoints/services/batchCheckpoints.tags';
import { integrationWebhooksTags } from '../pages/Commerce/services/integrationWebhooks.tags';
import { integrationRequestsTags } from '../pages/Commerce/services/integrationRequests.tags';
import { authorizationsTags } from '../pages/Authorizations/services/authorizations.tags';
import { transitControlTags } from '../pages/TransitControl/services/transitControl.tags';
import { pickupTransitionsTags } from '../pages/PickUp/services/pickupTransitions.tags';
import { returnsIntakeTags } from '../pages/ReturnsIntake/services/returnsIntake.tags';
import { arrivalScanTags } from '../pages/ArrivalScanning/services/arrivalScan.tags';
import { amendmentsTags } from '../pages/Amendments/services/amendments.tags';
import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQueryWithReauth } from '@/services';
import { API_BUSINESS_URL } from '@/utils';

export const businessService = createApi({
  reducerPath: 'businessService',
  baseQuery: createBaseQueryWithReauth(`${API_BUSINESS_URL}`),
  tagTypes: [
    ...returnsIntakeTags,
    ...arrivalScanTags,
    ...authorizationsTags,
    ...pickupTransitionsTags,
    ...batchCheckpointsTags,
    ...amendmentsTags,
    ...transitControlTags,
    ...integrationRequestsTags,
    ...integrationWebhooksTags,
    'ExportJobs',
    'ExportJobDetail',
    'BillingReports',
  ],
  endpoints: () => ({}),
});
